//TODO: remove file after migration

// Work In Progress V3 Report
export const mockedWorkInProgressReportData = [
  {
    repairerName: "John Smith",
    repairerGroup: "Group A",
    activeWebId: "WEB12345",
    schemeCode: "SC001",
    registration: "ABC1234",
    claimReference: "CLM0001",
    status: "In Progress",
    dtgCreated: "2024-04-01T08:30:00Z",
    dtgOnsite: "2024-04-02T09:00:00Z",
    dtgAuthorised: "2024-04-01T10:00:00Z",
    dtgPartsOrdered: "2024-04-03T11:00:00Z",
    dtgEstimatedCompletion: "2024-04-10T17:00:00Z",
    dtgReplacementVehicleKeysOut: "2024-04-02T12:00:00Z",
    replacementVehicleKeysOut: "Yes",
    replacementVehicleModel: "Toyota Corolla",
    dtgLastDataUpdate: "2024-04-04T14:00:00Z",
    dtgLastStatusChange: "2024-04-04T15:00:00Z",
    dtgLastActivity: "2024-04-04T16:00:00Z",
    lastActivityBy: "John Smith",
    dtgLatestPdelay: null,
    statusAge: 3,
    dataAge: 1,
    lastActivityAge: 0,
    reportMode: "Detailed"
  },
  {
    repairerName: "Emily Johnson",
    repairerGroup: "Group B",
    activeWebId: "WEB67890",
    schemeCode: "SC002",
    registration: "XYZ5678",
    claimReference: "CLM0002",
    status: "Awaiting Parts",
    dtgCreated: "2024-03-28T07:45:00Z",
    dtgOnsite: "2024-03-29T08:15:00Z",
    dtgAuthorised: "2024-03-28T09:00:00Z",
    dtgPartsOrdered: "2024-03-30T10:30:00Z",
    dtgEstimatedCompletion: "2024-04-12T16:00:00Z",
    dtgReplacementVehicleKeysOut: null,
    replacementVehicleKeysOut: "No",
    replacementVehicleModel: "Ford Focus",
    dtgLastDataUpdate: "2024-04-01T13:00:00Z",
    dtgLastStatusChange: "2024-04-01T14:00:00Z",
    dtgLastActivity: "2024-04-01T15:00:00Z",
    lastActivityBy: "Emily Johnson",
    dtgLatestPdelay: "2024-04-02T10:00:00Z",
    statusAge: 7,
    dataAge: 3,
    lastActivityAge: 2,
    reportMode: "Summary"
  },
  {
    repairerName: "Michael Brown",
    repairerGroup: "Group C",
    activeWebId: "WEB11223",
    schemeCode: "SC003",
    registration: "LMN3456",
    claimReference: "CLM0003",
    status: "Completed",
    dtgCreated: "2024-03-20T06:00:00Z",
    dtgOnsite: "2024-03-21T07:00:00Z",
    dtgAuthorised: "2024-03-20T08:00:00Z",
    dtgPartsOrdered: "2024-03-22T09:00:00Z",
    dtgEstimatedCompletion: "2024-03-28T17:00:00Z",
    dtgReplacementVehicleKeysOut: "2024-03-21T10:00:00Z",
    replacementVehicleKeysOut: "Yes",
    replacementVehicleModel: "Honda Civic",
    dtgLastDataUpdate: "2024-03-29T12:00:00Z",
    dtgLastStatusChange: "2024-03-29T13:00:00Z",
    dtgLastActivity: "2024-03-29T14:00:00Z",
    lastActivityBy: "Michael Brown",
    dtgLatestPdelay: null,
    statusAge: 0,
    dataAge: 1,
    lastActivityAge: 1,
    reportMode: "Detailed"
  },
  {
    repairerName: "Sarah Davis",
    repairerGroup: "Group A",
    activeWebId: "WEB44556",
    schemeCode: "SC004",
    registration: "QRS7890",
    claimReference: "CLM0004",
    status: "Pending Authorisation",
    dtgCreated: "2024-04-05T09:00:00Z",
    dtgOnsite: null,
    dtgAuthorised: null,
    dtgPartsOrdered: null,
    dtgEstimatedCompletion: null,
    dtgReplacementVehicleKeysOut: null,
    replacementVehicleKeysOut: "No",
    replacementVehicleModel: "Nissan Altima",
    dtgLastDataUpdate: "2024-04-05T10:00:00Z",
    dtgLastStatusChange: "2024-04-05T10:30:00Z",
    dtgLastActivity: "2024-04-05T11:00:00Z",
    lastActivityBy: "Sarah Davis",
    dtgLatestPdelay: null,
    statusAge: 1,
    dataAge: 0,
    lastActivityAge: 0,
    reportMode: "Summary"
  },
  {
    repairerName: "David Wilson",
    repairerGroup: "Group B",
    activeWebId: "WEB77889",
    schemeCode: "SC005",
    registration: "TUV1234",
    claimReference: "CLM0005",
    status: "On Hold",
    dtgCreated: "2024-03-15T05:30:00Z",
    dtgOnsite: "2024-03-16T06:00:00Z",
    dtgAuthorised: "2024-03-15T07:00:00Z",
    dtgPartsOrdered: "2024-03-17T08:00:00Z",
    dtgEstimatedCompletion: "2024-04-01T17:00:00Z",
    dtgReplacementVehicleKeysOut: null,
    replacementVehicleKeysOut: "No",
    replacementVehicleModel: "Chevrolet Malibu",
    dtgLastDataUpdate: "2024-03-20T09:00:00Z",
    dtgLastStatusChange: "2024-03-20T10:00:00Z",
    dtgLastActivity: "2024-03-20T11:00:00Z",
    lastActivityBy: "David Wilson",
    dtgLatestPdelay: "2024-03-25T12:00:00Z",
    statusAge: 10,
    dataAge: 5,
    lastActivityAge: 4,
    reportMode: "Detailed"
  }
];

// Vehicles on Site
export const mockedVehiclesOnSiteReportData = [
  {
    repairerName: "Pinetree EVAL Lee",
    schemeCode: "AVANT_ALLI",
    regMark: "ACCO1",
    claimID: 7,
    localStatus: "PARTS ORDER",
    manufacturer: "Unknown",
    model: "",
    dtgCreated: "2026-02-23T10:54:59",
    dtgBookedIn: "2026-02-23T11:00:00",
    dtgOnSite: "2026-02-23T10:56:45",
    courtesyMake: "",
    replacementReg: null,
    claimReference: "ABCD123EFG"
  },
  {
    repairerName: "FMG Repair Services (Barnstaple)",
    schemeCode: "ADMIRAL",
    regMark: "PSL73Y",
    claimID: 2772,
    localStatus: "CANCELLED",
    manufacturer: "Peugeot",
    model: "305",
    dtgCreated: "2026-02-02T15:05:20",
    dtgBookedIn: "2026-02-05T00:00:00",
    dtgOnSite: "2026-02-05T12:50:58",
    courtesyMake: "",
    replacementReg: null,
    claimReference: "AdmiralTestFMGA"
  },
  {
    repairerName: "BMS DXTEST TEST DLG A (REST)",
    schemeCode: "DIRECT",
    regMark: "AD16CDE",
    claimID: 3142948,
    localStatus: "FINISHED",
    manufacturer: "Ford",
    model: "Endeavour",
    dtgCreated: "2026-02-07T11:05:24",
    dtgBookedIn: "2026-02-08T11:05:24",
    dtgOnSite: "2026-02-09T11:05:24",
    courtesyMake: "HONDA",
    replacementReg: "CC123AC",
    claimReference: "CLM-2026-03022606"
  },
  {
    repairerName: "Pinetree Repairer1",
    schemeCode: "DLGDLINE",
    regMark: "TESTAT34",
    claimID: 2213,
    localStatus: "ON SITE",
    manufacturer: "Alfa Romeo",
    model: "",
    dtgCreated: "2026-02-27T15:38:15",
    dtgBookedIn: "2026-02-27T09:00:00",
    dtgOnSite: "2026-02-27T15:38:35",
    courtesyMake: "",
    replacementReg: null,
    claimReference: ""
  },
  {
    repairerName: "FMG Repair Services (Barnstaple)",
    schemeCode: "ADMIRAL",
    regMark: "FD64HFV",
    claimID: 2782,
    localStatus: "FINISHED",
    manufacturer: "Acura*",
    model: "TEST",
    dtgCreated: "2026-02-06T14:35:09",
    dtgBookedIn: "2026-02-06T00:00:00",
    dtgOnSite: "2026-02-06T14:54:03",
    courtesyMake: "",
    replacementReg: null,
    claimReference: "2000914969"
  },
  {
    repairerName: "Fix Auto Daventry",
    schemeCode: "FIXADM",
    regMark: "AVM1",
    claimID: 2000920644,
    localStatus: "FINISHED",
    manufacturer: "LAMBORGHINI*",
    model: "URUS",
    dtgCreated: "2026-02-23T11:30:08",
    dtgBookedIn: null,
    dtgOnSite: "2026-02-23T20:45:05",
    courtesyMake: "",
    replacementReg: null,
    claimReference: "2000920644"
  },
]

// Email Report
export const mockedEmailReports = [
  {
    repairerName: "John Smith",
    repairerGroup: "Group A",
    schemeCode: "SC001",
    workProvider: "Provider 1",
    siteCode: "SITE01",
    emailSentDate: "2024-04-20",
    subject: "Repair Confirmation",
    regmark: "ABC1234"
  },
  {
    repairerName: "Anna Brown",
    repairerGroup: "Group B",
    schemeCode: "SC002",
    workProvider: "Provider 2",
    siteCode: "SITE02",
    emailSentDate: "2024-04-21",
    subject: "Parts Order",
    regmark: "XYZ5678"
  },
  {
    repairerName: "Peter Wilson",
    repairerGroup: "Group A",
    schemeCode: "SC003",
    workProvider: "Provider 3",
    siteCode: "SITE03",
    emailSentDate: "2024-04-22",
    subject: "Repair Completion",
    regmark: "DEF4321"
  },
  {
    repairerName: "Catherine Green",
    repairerGroup: "Group C",
    schemeCode: "SC004",
    workProvider: "Provider 1",
    siteCode: "SITE04",
    emailSentDate: "2024-04-23",
    subject: "Collection Reminder",
    regmark: "GHI8765"
  },
  {
    repairerName: "Mark Lewis",
    repairerGroup: "Group B",
    schemeCode: "SC005",
    workProvider: "Provider 2",
    siteCode: "SITE05",
    emailSentDate: "2024-04-24",
    subject: "Repair On Hold",
    regmark: "JKL0987"
  }
];

// CSI Trigger Report
export const mockedCSIReportData = [
  {
    registration: 'ABC123',
    claimReference: 'CR789',
    manufacturer: 'Toyota',
    model: 'Camry',
    ownerName: 'John Doe',
    ownerEmail: 'johndoe@example.com',
    ownerMobile: '123-456-7890',
    dateReturned: '2000-01-01T00:00:00',
    elapsedK2K: 5,
    name: 'Jane Smith',
    comments: 'Vehicle repaired and returned to owner.',
  },
  {
    registration: 'DEF456',
    claimReference: 'CR790',
    manufacturer: 'Honda',
    model: 'Civic',
    ownerName: 'Alice Johnson',
    ownerEmail: 'alicejohnson@example.com',
    ownerMobile: '234-567-8901',
    dateReturned: '2001-02-15T10:30:00',
    elapsedK2K: 7,
    name: 'Bob Brown',
    comments: 'Routine maintenance completed.'
  },
  {
    registration: 'GHI789',
    claimReference: 'CR791',
    manufacturer: 'Ford',
    model: 'Focus',
    ownerName: 'Michael Green',
    ownerEmail: 'michaelgreen@example.com',
    ownerMobile: '345-678-9012',
    dateReturned: '2002-03-20T14:45:00',
    elapsedK2K: 3,
    name: 'Sara White',
    comments: 'Replaced brake pads.'
  },
  {
    registration: 'JKL012',
    claimReference: 'CR792',
    manufacturer: 'BMW',
    model: 'X5',
    ownerName: 'David Black',
    ownerEmail: 'davidblack@example.com',
    ownerMobile: '456-789-0123',
    dateReturned: '2003-04-25T09:15:00',
    elapsedK2K: 10,
    name: 'Emma Wilson',
    comments: 'Engine diagnostics and repair.'
  },
  {
    registration: 'MNO345',
    claimReference: 'CR793',
    manufacturer: 'Audi',
    model: 'A4',
    ownerName: 'Linda Blue',
    ownerEmail: 'lindablue@example.com',
    ownerMobile: '567-890-1234',
    dateReturned: '2004-05-30T16:00:00',
    elapsedK2K: 8,
    name: 'James Taylor',
    comments: 'Transmission fluid changed.'
  },
  {
    registration: 'PQR678',
    claimReference: 'CR794',
    manufacturer: 'Mercedes',
    model: 'C-Class',
    ownerName: 'Robert Gray',
    ownerEmail: 'robertgray@example.com',
    ownerMobile: '678-901-2345',
    dateReturned: '2005-06-10T11:20:00',
    elapsedK2K: 6,
    name: 'Olivia Martin',
    comments: 'Repaired air conditioning system.'
  },
  {
    registration: 'STU901',
    claimReference: 'CR795',
    manufacturer: 'Nissan',
    model: 'Altima',
    ownerName: 'Patricia King',
    ownerEmail: 'patriciaking@example.com',
    ownerMobile: '789-012-3456',
    dateReturned: '2006-07-15T13:50:00',
    elapsedK2K: 4,
    name: 'William Scott',
    comments: 'Battery replaced.'
  },
  {
    registration: 'VWX234',
    claimReference: 'CR796',
    manufacturer: 'Hyundai',
    model: 'Elantra',
    ownerName: 'Barbara Lee',
    ownerEmail: 'barbaralee@example.com',
    ownerMobile: '890-123-4567',
    dateReturned: '2007-08-20T08:40:00',
    elapsedK2K: 9,
    name: 'Charles Young',
    comments: 'Tire rotation and alignment. Test message for long items. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
  }
];

// Detailed Cycle Time Report with Exceptions
export const mockedDetailedCycleTimeReportData = [
  {
    repairer: "DLG Auto Services (Bristol)",
    siteCode: "DLG_BRI",
    repairerGroup: "DLGAS",
    activeWebID: "DLG_BRI.25731301",
    registration: "RE05HKB",
    stream: "NARGDLGCH",
    manufacturer: "Volvo",
    fnolToOnsite: 1,
    onSiteToStarted: 2,
    startedToCompleted: 3,
    completedToDelivered: 4,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 6,
    hours: 7,
    affectsCycleTime: 9,
    createdDTG: "2024-06-07T15:23:28"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2282",
    registration: "HJ69FEX",
    stream: "NARGDLGCH",
    manufacturer: "Unknown",
    fnolToOnsite: 8,
    onSiteToStarted: 11,
    startedToCompleted: 12,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 6,
    hours: 45,
    affectsCycleTime: 0,
    createdDTG: "2024-06-07T14:25:18"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2278",
    registration: "Y2",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 0.8,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 20,
    affectsCycleTime: 0,
    createdDTG: "2024-06-05T13:11:29"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2279",
    registration: "R2",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 0.8,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 9,
    affectsCycleTime: 0,
    createdDTG: "2024-06-05T13:17:34"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2287",
    registration: "BB52BBB",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 0,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 3,
    affectsCycleTime: 0,
    createdDTG: "2024-06-19T15:33:02"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2288",
    registration: "BB52BBB",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 3.1,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 5,
    affectsCycleTime: 0,
    createdDTG: "2024-06-21T08:03:35"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2305",
    registration: "GU07CHZ",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 1.1,
    onSiteToStarted: 0.1,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0.1,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 0.9,
    affectsCycleTime: 0,
    createdDTG: "2024-07-17T09:34:22"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2307",
    registration: "GU07CHZ",
    stream: "RSADEF",
    manufacturer: "BMW",
    fnolToOnsite: 1,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 0.9,
    affectsCycleTime: 0,
    createdDTG: "2024-07-22T14:22:02"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2308",
    registration: "JMN258N",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 0.9,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 0.9,
    affectsCycleTime: 0,
    createdDTG: "2024-07-22T14:22:02"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2289",
    registration: "R1",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 3.1,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 5,
    affectsCycleTime: 0,
    createdDTG: "2024-06-21T08:09:39"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2290",
    registration: "BB52BBB",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 3,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 5,
    affectsCycleTime: 0,
    createdDTG: "2024-06-21T08:27:49"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2291",
    registration: "BB52BBB",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 3,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 5,
    affectsCycleTime: 0,
    createdDTG: "2024-06-21T08:33:54"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2296",
    registration: "BB52BBB",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 0.1,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 500,
    affectsCycleTime: 0,
    createdDTG: "2024-06-27T07:39:01"
  },
  {
    repairer: "Pinetree Consulting - Spence",
    siteCode: "SPENCE",
    repairerGroup: "REMOVE",
    activeWebID: "SPENCE.2297",
    registration: "BB52BBB",
    stream: "RSADEF",
    manufacturer: "Unknown",
    fnolToOnsite: 0,
    onSiteToStarted: 0,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 5000,
    affectsCycleTime: 0,
    createdDTG: "2024-06-27T07:51:10"
  },
  {
    repairer: "Pinetree Repairer1",
    siteCode: "EVAL_DEV1",
    repairerGroup: "PINETREE",
    activeWebID: "EVAL_DEV1.1532",
    registration: "DLG02API",
    stream: "DLGDLINE",
    manufacturer: "Unknown",
    fnolToOnsite: 6.1,
    onSiteToStarted: 0.9,
    startedToCompleted: 0,
    completedToDelivered: 0,
    keyToKey: 0.9,
    fnolToDelivered: null,
    fnolToInvoiced: 0,
    hours: 0.9,
    affectsCycleTime: 0,
    createdDTG: "2024-08-07T15:25:32"
  },
];

// WP Site Connections
export const mockedWPSiteConReportData = [
  {
    systemType: "AUTOSOFT",
    siteCode: "0511",
    address: "24 iffracomb avenue",
    postcode: "rg41 1np2",
    name: "11May-Repairer-Test",
    repairerGroup: "TEST-GROUP-11MAY",
    connectionDetails: "Connected CAPS",
    capsCodes: "N.A."
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "0518",
    address: "26 court road",
    postcode: "rgi 8aq",
    name: "May18-Rep",
    repairerGroup: "REPGROUP",
    connectionDetails: "Connected STD",
    capsCodes: "N.A."
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "0522",
    address: "hyd",
    postcode: "rg73ty",
    name: "Reptest22may",
    repairerGroup: "FIXAUTO",
    connectionDetails: "Connected CAPS",
    capsCodes: "N.A."
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "053123",
    address: "23fderf",
    postcode: "rg57yg",
    name: "NewMay31Rep",
    repairerGroup: "INDEPENDENT",
    connectionDetails: "Connected CAPS",
    capsCodes: "test_caps"
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "0612",
    address: "1 Hawkedon way",
    postcode: "rg6 4bh",
    name: "May12-NewRepairer",
    repairerGroup: "NEWRGROUP",
    connectionDetails: "Connected NARG",
    capsCodes: "KVS002"
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "1112302",
    address: "123, test",
    postcode: "380051",
    name: "Test repairer2 1Nov2023",
    repairerGroup: "TEST",
    connectionDetails: "Connected STD",
    capsCodes: "N.A."
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "12345",
    address: "test street",
    postcode: "12-345",
    name: "Ewelina Test",
    repairerGroup: "TEST",
    connectionDetails: "Connected NARG (12345)",
    capsCodes: "N.A."
  },
  {
    systemType: "AUTOSOFT",
    siteCode: "2205",
    address: "liverpol",
    postcode: "rg57yg",
    name: "TestRep22May",
    repairerGroup: "FIXAUTO",
    connectionDetails: "Connected CAPS",
    capsCodes: "rep_caps"
  },
]

// Repairer Capacity Report 1
export const mockedMeasureRolling30DayReportData = [
  {
    measureName: 'NotificationsDeployed',
    c0: null,
    c1: null,
    c2: 69,
    c3: 438,
    c4: 307,
    c5: 266,
    c6: 265,
    c7: 113,
    c8: null,
    c9: 14,
    c10: null,
    c11: 407,
    c12: null,
    c13: 300,
    c14: null,
    c15: 291,
    c16: null,
    c17: 221,
    c18: null,
    c19: 290,
    c20: null,
    c21: 99,
    c22: null,
    c23: null,
    c24: null,
    c25: null,
    c26: 37,
    c27: null,
    c28: 446,
    c29: null,
    c30: 258,
    c31: null,
  },
];

export const mockMeasureFuture30DayReportData = [
  {
    measureName: 'FutureBookinImmobile',
    c0: null,
    c1: 102,
    c2: 70,
    c3: 36,
    c4: 24,
    c5: 1,
    c6: 8,
    c7: null,
    c8: 13,
    c9: null,
    c10: 8,
    c11: null,
    c12: 7,
    c13: null,
    c14: 8,
    c15: null,
    c16: 5,
    c17: null,
    c18: null,
    c19: null,
    c20: null,
    c21: null,
    c22: 5,
    c23: null,
    c24: 3,
    c25: null,
    c26: null,
    c27: 1,
    c28: null,
    c29: null,
    c30: null,
    c31: null,
  },
];

// NPS Summary Report V4
export const mockedNPSSummaryReportData = [
  {
    schemecode: "DLG2024",
    siteName: "DLG Auto Services (Heywood)",
    siteCode: "DLG_HEY",
    noResponse: 5,
    detractor: 1,
    passive: 2,
    promotor: 3,
    groupingValue: "Group A",
    totalResponses: 5,
    totalRows: 6,
    dateStarted: "2024-01-01T08:00:00Z",
    dateEnded: "2024-06-30T17:00:00Z",
    npsScore: 20,
    monthYearGroupings: [
      {
        name: "2024/27",
        value: 1
      },
      {
        name: "2024/28",
        value: 4
      },
      {
        name: "2025/06",
        value: 2
      },
      {
        name: "2025/40",
        value: 2
      },
      {
        name: "2025/41",
        value: 1
      },
      {
        name: "2025/45",
        value: 3
      }
    ],
    repairerGroup: "DLGAS"
  },
  {
    schemecode: "FMG2024",
    siteName: "FMG Repair Services (Littlehampton)",
    siteCode: "NW_LT",
    noResponse: 2,
    detractor: 0,
    passive: 1,
    promotor: 1,
    groupingValue: "Group B",
    totalResponses: 8,
    totalRows: 8,
    dateStarted: "2024-02-01T09:00:00Z",
    dateEnded: "2024-05-31T16:00:00Z",
    npsScore: -5,
    monthYearGroupings: [
      {
        name: "2024/27",
        value: 3
      },
      {
        name: "2024/28",
        value: 1
      },
      {
        name: "2025/06",
        value: 5
      },
      {
        name: "2025/40",
        value: 2
      },
      {
        name: "2025/41",
        value: 1
      },
      {
        name: "2025/45",
        value: 4
      }
    ],
    repairerGroup: "NATIONWIDE"
  },
  {
    schemecode: "ITD2024",
    siteName: "IT_DIRECT",
    siteCode: "ITDRCT",
    noResponse: 2,
    detractor: 0,
    passive: 0,
    promotor: 2,
    groupingValue: "Group C",
    totalResponses: 3,
    totalRows: 3,
    dateStarted: "2024-03-01T10:00:00Z",
    dateEnded: "2024-06-30T15:00:00Z",
    npsScore: 100,
    monthYearGroupings: [
      {
        name: "2024/27",
        value: 1
      },
      {
        name: "2024/28",
        value: 3
      },
      {
        name: "2025/06",
        value: 4
      },
      {
        name: "2025/40",
        value: 2
      },
      {
        name: "2025/41",
        value: 1
      },
      {
        name: "2025/45",
        value: 5
      }
    ],
    repairerGroup: "IT_DIRECT"
  },
  {
    schemecode: "TST2025",
    siteName: "TestAdmiral18072025_2",
    siteCode: "EWWEWE",
    noResponse: 2,
    detractor: 1,
    passive: 0,
    promotor: 1,
    groupingValue: "Group D",
    totalResponses: 2,
    totalRows: 2,
    dateStarted: "2025-01-01T08:30:00Z",
    dateEnded: "2025-07-18T17:30:00Z",
    npsScore: 0,
    monthYearGroupings: [
      {
        name: "2024/27",
        value: 6
      },
      {
        name: "2024/28",
        value: 2
      },
      {
        name: "2025/06",
        value: 1
      },
      {
        name: "2025/40",
        value: 3
      },
      {
        name: "2025/41",
        value: 4
      },
      {
        name: "2025/45",
        value: 1
      }
    ],
    repairerGroup: "TESTADMIRAL18072025_"
  }
]

// SLA Performance V3 Report
export const mockedSLAReportData = [
  {
    workProviderName: "Direct Line Group",
    slaTitle: "Notification to First Contact",
    slaDescription: "Initial notification through to the first recorded customer contact",
    timeType: "W",
    repairerGroup: "DLGAS",
    repairerName: "DLG Auto Services (Bristol)",
    repairCode: "DLG_BRI.25960003",
    regMark: "BN16JZT",
    claimReference: "702776527",
    trackingStartDTG: null,
    startDTG: "2026-01-13T16:27:00",
    breachDTG: "2026-01-14T10:27:00",
    completedDTG: "2026-01-28T11:26:13.403",
    slaDuration: 5639,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-14 10:27:00.000",
    actualDataValue: "2026-01-28 11:26:13.403",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 1,
    slaBreach: 1,
    hashtag: "AAAA",
    eol: "N/A",
    stream: "DIRECT"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "Notification to First Contact",
    slaDescription: "Initial notification through to the first recorded customer contact",
    timeType: "W",
    repairerGroup: "INDEPENDENT",
    repairerName: "BMS DXTEST TEST DLG A (REST)",
    repairCode: "BMTSA.3142948",
    regMark: "AD16CDE",
    claimReference: "CLM-2026-03022606",
    trackingStartDTG: null,
    startDTG: "2026-02-07T11:05:24",
    breachDTG: "2026-02-09T11:00:00",
    completedDTG: "2026-02-07T11:05:24",
    slaDuration: 0,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-02-09 11:00:00.000",
    actualDataValue: "2026-02-07 11:05:24.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "ZZZZ",
    eol: "N/A",
    stream: "DIRECT"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "Notification to First Contact",
    slaDescription: "Initial notification through to the first recorded customer contact",
    timeType: "W",
    repairerGroup: "INDEPENDENT",
    repairerName: "BMS DXTEST TEST DLG A (REST)",
    repairCode: "BMTSA.10960002",
    regMark: "S5",
    claimReference: "702776600",
    trackingStartDTG: null,
    startDTG: "2026-01-09T13:00:00",
    breachDTG: "2026-01-09T16:00:00",
    completedDTG: "2026-01-28T11:26:10.073",
    slaDuration: 6926,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-09 16:00:00.000",
    actualDataValue: "2026-01-28 11:26:10.073",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 1,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "UKINSTP"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "Notification to First Contact",
    slaDescription: "Initial notification through to the first recorded customer contact",
    timeType: "W",
    repairerGroup: "INDEPENDENT",
    repairerName: "BMS DXTEST TEST DLG A (REST)",
    repairCode: "BMTSA.10960003",
    regMark: "WN18YEU",
    claimReference: "702778044",
    trackingStartDTG: null,
    startDTG: "2026-01-09T13:00:00",
    breachDTG: "2026-01-09T16:00:00",
    completedDTG: "2026-01-28T11:26:10.577",
    slaDuration: 6926,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-09 16:00:00.000",
    actualDataValue: "2026-01-28 11:26:10.577",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 1,
    slaBreach: 1,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "UKINSTP"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "OnSite to Completed",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "DLGAS",
    repairerName: "DLG Auto Services (Bristol)",
    repairCode: "DLG_BRI.25960004",
    regMark: "DE11PBZ",
    claimReference: "702786633",
    trackingStartDTG: null,
    startDTG: "2026-01-13T17:30:00",
    breachDTG: "2026-01-20T17:30:00",
    completedDTG: "2026-01-13T17:37:20",
    slaDuration: 7,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-20 17:30:00.000",
    actualDataValue: "2026-01-13 17:37:20.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "DIRECT"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "OnSite to Completed",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "DLGAS",
    repairerName: "DLG Auto Services (Bristol)",
    repairCode: "DLG_BRI.25960007",
    regMark: "S5",
    claimReference: "702867003",
    trackingStartDTG: null,
    startDTG: "2026-01-23T10:37:00",
    breachDTG: "2026-01-30T10:37:00",
    completedDTG: "2026-01-23T10:43:53",
    slaDuration: 6,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-30 10:37:00.000",
    actualDataValue: "2026-01-23 10:43:53.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "DIRECT"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "OnSite to Completed",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "DLGAS",
    repairerName: "DLG Auto Services (Bristol)",
    repairCode: "DLG_BRI.25960006",
    regMark: "BJ57TWM",
    claimReference: "702867003",
    trackingStartDTG: null,
    startDTG: "2026-01-23T10:28:00",
    breachDTG: "2026-01-30T10:28:00",
    completedDTG: "2026-01-23T10:34:14",
    slaDuration: 6,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-30 10:28:00.000",
    actualDataValue: "2026-01-23 10:34:14.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "DIRECT"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "OnSite to Completed",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "DLGAS",
    repairerName: "DLG Auto Services (Bristol)",
    repairCode: "DLG_BRI.25960005",
    regMark: "LS56RFN",
    claimReference: "702786674",
    trackingStartDTG: null,
    startDTG: "2026-01-13T18:24:00",
    breachDTG: "2026-01-20T18:24:00",
    completedDTG: "2026-01-13T18:31:37",
    slaDuration: 7,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-20 18:24:00.000",
    actualDataValue: "2026-01-13 18:31:37.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "DIRECT"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "OnSite to Completed",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "DLGAS",
    repairerName: "DLG Auto Services (Bristol)",
    repairCode: "DLG_BRI.25960003",
    regMark: "BN16JZT",
    claimReference: "702776527",
    trackingStartDTG: null,
    startDTG: "2026-01-13T16:49:00",
    breachDTG: "2026-01-20T16:49:00",
    completedDTG: "2026-01-13T16:50:33",
    slaDuration: 1,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-20 16:49:00.000",
    actualDataValue: "2026-01-13 16:50:33.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "DIRECT"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "OnSite to Completed",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "DLGAS",
    repairerName: "DLG Auto Services (Bristol)",
    repairCode: "DLG_BRI.25950001",
    regMark: "FE15KZZ",
    claimReference: "702454224/1",
    trackingStartDTG: null,
    startDTG: "2025-12-29T13:59:00",
    breachDTG: "2026-01-05T13:59:00",
    completedDTG: "2025-12-29T14:16:10",
    slaDuration: 17,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-05 13:59:00.000",
    actualDataValue: "2025-12-29 14:16:10.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "PRIV      "
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "OnSite to Completed",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "DLGAS",
    repairerName: "DLG Auto Services (Bristol)",
    repairCode: "DLG_BRI.25930031",
    regMark: "DE11PBZ",
    claimReference: "702786633",
    trackingStartDTG: null,
    startDTG: "2026-01-15T10:47:00",
    breachDTG: "2026-01-22T10:47:00",
    completedDTG: "2026-01-15T10:52:06",
    slaDuration: 5,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-22 10:47:00.000",
    actualDataValue: "2026-01-15 10:52:06.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "CHURCH    "
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "OnSite to Completed",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "DLGAS",
    repairerName: "DLG Auto Services (Bristol)",
    repairCode: "DLG_BRI.25950002",
    regMark: "TEST3",
    claimReference: "Unknown",
    trackingStartDTG: null,
    startDTG: "2025-12-30T09:09:00",
    breachDTG: "2026-01-06T09:09:00",
    completedDTG: "2025-12-30T09:19:44",
    slaDuration: 10,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-06 09:09:00.000",
    actualDataValue: "2025-12-30 09:19:44.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "DIRECT"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "OnSite to Completed",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "DLGAS",
    repairerName: "DLG Auto Services (Bristol)",
    repairCode: "DLG_BRI.25960001",
    regMark: "TEST3",
    claimReference: "1234",
    trackingStartDTG: null,
    startDTG: "2026-01-07T16:08:00",
    breachDTG: "2026-01-14T16:08:00",
    completedDTG: "2026-01-07T16:09:54",
    slaDuration: 1,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-14 16:08:00.000",
    actualDataValue: "2026-01-07 16:09:54.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "DIRECT"
  },
  {
    workProviderName: "Direct Line Group ",
    slaTitle: "OnSite to Completed Bookin Accuracy",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "INDEPENDENT",
    repairerName: "BMS DXTEST TEST DLG A (REST)",
    repairCode: "BMTSA.3142948",
    regMark: "AD16CDE",
    claimReference: "CLM-2026-03022606",
    trackingStartDTG: null,
    startDTG: "2026-02-09T11:05:24",
    breachDTG: "2026-02-16T11:05:24",
    completedDTG: "2026-02-12T11:30:24",
    slaDuration: 4345,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-02-16 11:05:24.000",
    actualDataValue: "2026-02-12 11:30:24.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "DIRECT"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "OnSite to Completed",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "INDEPENDENT",
    repairerName: "BMS DXTEST TEST DLG A (REST)",
    repairCode: "BMTSA.10960002",
    regMark: "S5",
    claimReference: "702776600",
    trackingStartDTG: null,
    startDTG: "2026-01-09T15:32:00",
    breachDTG: "2026-01-16T15:32:00",
    completedDTG: "2026-01-09T15:39:00",
    slaDuration: 7,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-16 15:32:00.000",
    actualDataValue: "2026-01-09 15:39:00.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "UKINSTP"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "OnSite to Completed",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "INDEPENDENT",
    repairerName: "BMS DXTEST TEST DLG A (REST)",
    repairCode: "BMTSA.10960003",
    regMark: "WN18YEU",
    claimReference: "702778044",
    trackingStartDTG: null,
    startDTG: "2026-01-09T15:41:00",
    breachDTG: "2026-01-16T15:41:00",
    completedDTG: "2026-01-09T15:45:57",
    slaDuration: 4,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-16 15:41:00.000",
    actualDataValue: "2026-01-09 15:45:57.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "UKINSTP"
  },
  {
    workProviderName: "Direct Line Group",
    slaTitle: "OnSite to Completed",
    slaDescription: "Vehicle OnSite to completion of repairs",
    timeType: "EBH",
    repairerGroup: "INDEPENDENT",
    repairerName: "BMS DXTEST TEST DLG A (REST)",
    repairCode: "BMTSA.10960004",
    regMark: "T5",
    claimReference: "702776352",
    trackingStartDTG: null,
    startDTG: "2026-01-09T15:48:00",
    breachDTG: "2026-01-16T15:48:00",
    completedDTG: "2026-01-09T15:53:54",
    slaDuration: 5,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-01-16 15:48:00.000",
    actualDataValue: "2026-01-09 15:53:54.000",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 0,
    hashtag: "#CHOICE",
    eol: "N/A",
    stream: "UKINSTP"
  },
  {
    workProviderName: "Allianz",
    slaTitle: "Notification to Bookin set or Onsite Bookin Accuracy",
    slaDescription: "Notification to book in arranged or vehicle on site",
    timeType: "W",
    repairerGroup: "INDEPENDENT",
    repairerName: "MARALL GARAGE",
    repairCode: "MAR_ALL.2133",
    regMark: "MONCAR2",
    claimReference: "545453535",
    trackingStartDTG: null,
    startDTG: "2026-02-06T09:59:38.993",
    breachDTG: "2026-02-11T17:00:00",
    completedDTG: "2026-02-16T09:04:36.953",
    slaDuration: 3185,
    count: 1,
    slaType: 0,
    expectedDataValue: "2026-02-11 17:00:00.000",
    actualDataValue: "2026-02-16 09:04:36.953",
    dataSuccess: null,
    slaCompleted: true,
    slaWarning: 1,
    slaBreach: 1,
    hashtag: "#CHOICE",
    eol: "Late",
    stream: "ALLIANZ"
  },
  {
    workProviderName: "Allianz",
    slaTitle: "Bookin Accuracy (Allianz)",
    slaDescription: "Does the actual onsite date match the final book in date set within the agreed period",
    timeType: "EBH",
    repairerGroup: "INDEPENDENT",
    repairerName: "MARALL GARAGE",
    repairCode: "MAR_ALL.2133",
    regMark: "MONCAR2",
    claimReference: "545453535",
    trackingStartDTG: null,
    startDTG: "2026-02-16T00:00:00",
    breachDTG: "2026-02-16T00:00:00",
    completedDTG: "2026-02-16T00:00:00",
    slaDuration: null,
    count: 1,
    slaType: 1,
    expectedDataValue: "2026-02-20",
    actualDataValue: "2026-02-16",
    dataSuccess: 0,
    slaCompleted: true,
    slaWarning: 0,
    slaBreach: 1,
    hashtag: "#CHOICE",
    eol: "Early",
    stream: "ALLIANZ"
  }
]


